<template>
  <p class="card-deeplink-message">
    You will be redirected
  </p>
</template>

<script>
export default {
  name: 'CardDeeplink',
  created() {
    const decks = this.$store.getters['decks/all'];
    const cardDeck = decks.find(d => {
      const deckCardIds = d.cards.map(c => c.id);
      return deckCardIds.includes(Number(this.$route.params.cardId));
    });
    if (cardDeck) {
      const card = cardDeck.cards.find(c => c.id === Number(this.$route.params.cardId));
      let route = {
        name: 'deeplinks#deck',
        params: {
          deckId: cardDeck.id,
        },
      };
      if (card.isTopicCard) {
        route = {
          name: 'deeplinks#topic',
          params: {
            topicId: card.assetId,
          },
        };
      } else if (card.isAttachmentCard) {
        route.query = { card: card.id };
      }
      this.$router.push(route);
    } else {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>

<style lang="scss" scoped>
.card-deeplink-message {
  visibility: hidden;
}
</style>